import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-drop-down-group-menu-plus',
    templateUrl: './drop-down-group-menu-plus.component.html',
    styleUrls: ['./drop-down-group-menu-plus.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                display: 'none', opacity: '0',
            })),
            state('block', style({
                display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('80ms linear'))
        ])
    ]
})
export class DropDownGroupMenuPlusComponent implements OnInit {
    changeOpen: Boolean = false;
    @Input() menusList: Array<any>;
    @Input() currentSys = 'åæ¢ç³»ç»';
    @Output() navHomeUrl = new EventEmitter(); // ä¸»é¡µè·³è½¬
    @Output() navUrl = new EventEmitter(); // äºçº§è·³è½¬

    menuMap = {};

    desk = [];


    navHome() {
        this.navHomeUrl.emit();
    }

    navSub(id) {
        this.navUrl.emit(id);
    }

    constructor() {
    }

    ngOnInit() {
        const self = this;
        for (let i = 0; i < self.menusList.length; i++) {

            if (!self.menuMap[self.menusList[i].systype]) {

                self.desk[self.menusList[i].systype] = [];
                self.desk[self.menusList[i].systype].push(
                    self.menusList[i]
                );

                self.menuMap[self.menusList[i].systype] = self.menusList[i];
            } else {
                self.desk[self.menusList[i].systype].push(
                    self.menusList[i]
                );
            }

        }

    }

}
